import React from 'react'
import _ from 'lodash'
import { InstantSearch, Configure } from 'react-instantsearch-dom'

import { nodeApiSearchItems } from 'mednet-util/src/search'

import AutoComplete from './questionAutoComplete'

// Shapes a /search/questions row like the Algolia hit this box rendered: the
// forms read question_id, and each suggestion shows the highlighted question.
export const mapQuestionRowToAlgoliaHit = (question) => ({
  objectID: `${question.questionId}`,
  question_id: question.questionId,
  question: question.question,
  _highlightResult: question._highlightResult ?? {
    question: { value: _.escape(question.question) },
  },
})

// Searches questions in Typesense through the node API.
export const nodeQuestionSearchClient = {
  search(requests) {
    const [request] = requests
    const { query, hitsPerPage } = request.params

    return nodeApiSearchItems('questions', {
      query,
      limit: hitsPerPage,
      statuses: [1],
      searchPlatform: 'TYPESENSE',
      trackSearchQuery: false,
    }).then((data) => ({
      results: [
        {
          hits: data.items.map(mapQuestionRowToAlgoliaHit),
          nbHits: data.pagination.total,
          page: 0,
          nbPages: 1,
          hitsPerPage,
          exhaustiveNbHits: true,
          query,
          params: '',
          processingTimeMS: 0,
          index: request.indexName,
        },
      ],
    }))
  },
}

const QuestionSearch = (props) => (
  <InstantSearch indexName="questions" searchClient={nodeQuestionSearchClient}>
    <AutoComplete {...props} />

    <Configure hitsPerPage={5} />
  </InstantSearch>
)

export default QuestionSearch
